
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Research from './components/Research';
import Investment from './components/Investment';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CurrencyTicker from '../../components/feature/CurrencyTicker';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <CurrencyTicker />
      <Header />
      <Hero />
      <About />
      <Services />
      <Research />
      <Investment />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
